import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fulfillmentApi, type FulfillmentBoardQuery } from "./client";

const keys = {
  board: (query?: FulfillmentBoardQuery) =>
    ["fulfillment", "board", query] as const,
  pack: () => ["fulfillment", "pack"] as const,
};

export function useFulfillmentBoardQuery(query?: FulfillmentBoardQuery) {
  return useQuery({
    queryKey: keys.board(query),
    queryFn: () => fulfillmentApi.board(query),
  });
}

export function usePackQueueQuery() {
  return useQuery({
    queryKey: keys.pack(),
    queryFn: () => fulfillmentApi.packQueue(),
  });
}

export function useInvalidateFulfillmentBoard() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ["fulfillment"] });
}
